/* external links new window */
var links = document.links;
if (links.length > 0) {
  for(var i = 0; i < links.length; i++) {
    if (links[i].hostname != window.location.hostname)
      links[i].target = '_blank'
  }
}

window.onload = function(event) {
  document.body.classList.add("page-loaded");
};